/**
 * The map outside Panamá and Venezuela (Martín, 2 Nov 2026: any business in the
 * world). Dale's own tiles (`@dale/map`, PMTiles in R2) cover only those two
 * countries, so elsewhere the pin goes on OpenFreeMap: OpenStreetMap vector
 * tiles, free, with no key and allowed for commercial use. Its host is in the
 * connect-src of public/_headers.
 */
export const WORLD_MAP_STYLE = 'https://tiles.openfreemap.org/styles/positron';

/** Close enough to see the streets of the area the owner wrote. */
export const WORLD_AREA_ZOOM = 13;
